import "./style.scss";
import ButtonUi from "@UI/ButtonUi";
import DefaultListItem from "../../Default/ListItem";

const ListItem = ({ isSberPrime = false, ...props }) => {
    if (!isSberPrime) {
        return <DefaultListItem {...props} />;
    }

    const { handleClick = () => {}, typeLabel = "хит", item = null } = props;

    return (
        item && (
            <div className={`ab-4031-v3 list-item hit`} id={item._id} onClick={handleClick}>
                <div className="list-item__logo">
                    <img alt={`logo_desktop`} src={props.cover} />
                </div>
                <div className="list-item__title-container">
                    <span className={`list-item__title`} dangerouslySetInnerHTML={{ __html: item.title }}></span>
                </div>
                <span className={`list-item__hit-label_block hit`}>{typeLabel}</span>
                <ButtonUi label="Забрать" className="list-item__sber-btn" />
            </div>
        )
    );
};

export default ListItem;
